import * as Scrivito from "scrivito"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import {
  LandingPageAttributes,
  LandingPageObjClass
} from "./LandingPageObjClass"
import "./styles/_landing-page.scss"

function LandingPageComponent({
  page
}: Scrivito.PageComponentProps<LandingPageAttributes>) {
  useScrivitoPage()
  useScrollController()

  return (
    <Scrivito.ContentTag
      data-testid="landing-page"
      className="landing-page"
      content={page}
      attribute="body"
    />
  )
}

Scrivito.provideComponent(LandingPageObjClass, LandingPageComponent)
